module.exports = "<headerMenu></headerMenu>\r\n\r\n<div class=\" col-md-12 col-lg-12 agent_div p0d\">\r\n  <app-cardlist></app-cardlist>\r\n</div>\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/sendMoney/debitcard/debitcard.component.html
// module id = ./src/app/sendMoney/debitcard/debitcard.component.html
// module chunks = main